import { Component } from 'react';

import { CardNumberElement } from '@stripe/react-stripe-js';
import {
    StripeCardNumberElement,
    StripeCardNumberElementChangeEvent
} from '@stripe/stripe-js';
import { FormattedMessage } from 'react-intl';

import messages from './LinkDebitCard.messages';
import styles from './LinkDebitCard.module.css';
import { stripeElementStyles } from './StripeElementStyles';

export class CardNumberQuestion extends Component<{
    error: {
        invalidNumber?: boolean | null;
        invalidCardType?: boolean | null;
        invalidCard?: boolean | null;
        invalidType?: boolean | null;
    };
    onChange: (arg: StripeCardNumberElementChangeEvent) => void;
    onReady: (element: StripeCardNumberElement) => void;
}> {
    renderError() {
        const { error } = this.props;

        if (error.invalidCardType) {
            return (
                <span className={styles.error}>
                    <FormattedMessage {...messages.cardTypeNotDebitError} />
                </span>
            );
        } else if (error.invalidNumber) {
            return (
                <span className={styles.error}>
                    <FormattedMessage {...messages.cardNumberError} />
                </span>
            );
        }

        return null;
    }

    render() {
        const { onChange, onReady } = this.props;
        const error = this.renderError();

        return (
            <div className={styles.field}>
                <label className={styles.label}>
                    <FormattedMessage {...messages.cardNumber} />
                </label>
                {error}
                <CardNumberElement
                    onReady={onReady}
                    onChange={onChange}
                    options={{
                        style: stripeElementStyles
                    }}
                />
            </div>
        );
    }
}
